import { CLEAR_PRELOAD_SEED } from '../../../../shared-react/src/store/types';

export const clearPreloadSeed = () => {
  return (dispatch) =>
    dispatch({
      type: CLEAR_PRELOAD_SEED,
    });
};
